import React, { Component } from 'react'
import '../styles/UsgsCommons.scss'
import '../styles/UsgsCustom.scss'

class UsgsHeader extends Component {

  render() {
    return (
      <div className="usgs">
        <header id="navbar" className="header-nav" role="banner">
          <div className="tmp-container">
            <div className="header-search">
              <a className="logo-header" href="https://www.usgs.gov/" title="Home">
                <img className="img" src={require('../logo.png')?.default} alt="USGS - science for a changing world" title="U.S. Geological Survey Home Page"/>
              </a>
            </div>
          </div>
        </header>
      </div>
    )
  }
}

export default UsgsHeader
